import styledC from 'styled-components';

import Box from '../Box';

const Flex = styledC(Box)`
  display: flex;
`;

export default Flex;
